/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EmployeeFromJSON, EmployeeToJSON, NotificationRecurringFromJSON, NotificationRecurringToJSON, } from './';
export function ApplicationUserFromJSON(json) {
    return ApplicationUserFromJSONTyped(json, false);
}
export function ApplicationUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'normalizedUserName': !exists(json, 'normalizedUserName') ? undefined : json['normalizedUserName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'normalizedEmail': !exists(json, 'normalizedEmail') ? undefined : json['normalizedEmail'],
        'emailConfirmed': !exists(json, 'emailConfirmed') ? undefined : json['emailConfirmed'],
        'passwordHash': !exists(json, 'passwordHash') ? undefined : json['passwordHash'],
        'securityStamp': !exists(json, 'securityStamp') ? undefined : json['securityStamp'],
        'concurrencyStamp': !exists(json, 'concurrencyStamp') ? undefined : json['concurrencyStamp'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneNumberConfirmed': !exists(json, 'phoneNumberConfirmed') ? undefined : json['phoneNumberConfirmed'],
        'twoFactorEnabled': !exists(json, 'twoFactorEnabled') ? undefined : json['twoFactorEnabled'],
        'lockoutEnd': !exists(json, 'lockoutEnd') ? undefined : (json['lockoutEnd'] === null ? null : new Date(json['lockoutEnd'])),
        'lockoutEnabled': !exists(json, 'lockoutEnabled') ? undefined : json['lockoutEnabled'],
        'accessFailedCount': !exists(json, 'accessFailedCount') ? undefined : json['accessFailedCount'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'created': !exists(json, 'created') ? undefined : (json['created'] === null ? null : new Date(json['created'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedBy': !exists(json, 'deletedBy') ? undefined : ApplicationUserFromJSON(json['deletedBy']),
        'deletedById': !exists(json, 'deletedById') ? undefined : json['deletedById'],
        'deleted': !exists(json, 'deleted') ? undefined : (json['deleted'] === null ? null : new Date(json['deleted'])),
        'deletedNormalizedUserName': !exists(json, 'deletedNormalizedUserName') ? undefined : json['deletedNormalizedUserName'],
        'notificationsRecurring': !exists(json, 'notificationsRecurring') ? undefined : (json['notificationsRecurring'] === null ? null : json['notificationsRecurring'].map(NotificationRecurringFromJSON)),
        'employee': !exists(json, 'employee') ? undefined : EmployeeFromJSON(json['employee']),
    };
}
export function ApplicationUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'userName': value.userName,
        'normalizedUserName': value.normalizedUserName,
        'email': value.email,
        'normalizedEmail': value.normalizedEmail,
        'emailConfirmed': value.emailConfirmed,
        'passwordHash': value.passwordHash,
        'securityStamp': value.securityStamp,
        'concurrencyStamp': value.concurrencyStamp,
        'phoneNumber': value.phoneNumber,
        'phoneNumberConfirmed': value.phoneNumberConfirmed,
        'twoFactorEnabled': value.twoFactorEnabled,
        'lockoutEnd': value.lockoutEnd === undefined ? undefined : (value.lockoutEnd === null ? null : value.lockoutEnd.toISOString()),
        'lockoutEnabled': value.lockoutEnabled,
        'accessFailedCount': value.accessFailedCount,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'companyName': value.companyName,
        'isActive': value.isActive,
        'createdById': value.createdById,
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'created': value.created === undefined ? undefined : (value.created === null ? null : value.created.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedBy': ApplicationUserToJSON(value.deletedBy),
        'deletedById': value.deletedById,
        'deleted': value.deleted === undefined ? undefined : (value.deleted === null ? null : value.deleted.toISOString()),
        'deletedNormalizedUserName': value.deletedNormalizedUserName,
        'notificationsRecurring': value.notificationsRecurring === undefined ? undefined : (value.notificationsRecurring === null ? null : value.notificationsRecurring.map(NotificationRecurringToJSON)),
        'employee': EmployeeToJSON(value.employee),
    };
}
